import { Avatar, AvatarProps } from '@mui/material'
import { EinwertLogoIconDark, tokens } from 'ComponentLibrary'
import { ThreadType } from 'ComponentLibrary/src/common/threads'
import { ReactNode } from 'react'
import { ChatsCircle, ClipboardText } from '@phosphor-icons/react'

type ThreadAvatarProps = {
    type: ThreadType
}

type BaseAvatarProps = { children: ReactNode; sx?: AvatarProps['sx'] }

const BaseAvatar = ({ children, sx }: BaseAvatarProps) => {
    return (
        <Avatar
            sx={{
                backgroundColor: tokens.ColorBackgroundLight,
                border: `1px solid ${tokens.ColorBorderDefault}`,
                weight: 'bold',
                width: '36px',
                height: '36px',
                ...sx,
            }}
        >
            {children}
        </Avatar>
    )
}

type SharedAvatarProps = Pick<BaseAvatarProps, 'sx'>

const MessageAvatar = (props: SharedAvatarProps) => {
    return (
        <BaseAvatar {...props}>
            <ChatsCircle color={tokens.ColorIconBoldest} weight="bold" />
        </BaseAvatar>
    )
}

const TaskMessageAvatar = (props: SharedAvatarProps) => {
    return (
        <BaseAvatar {...props}>
            <ClipboardText color={tokens.ColorIconBoldest} weight="bold" />
        </BaseAvatar>
    )
}

const SystemMessageAvatar = (props: SharedAvatarProps) => {
    return (
        <BaseAvatar {...props}>
            <EinwertLogoIconDark width="100%" height="100%" />
        </BaseAvatar>
    )
}
export const ThreadAvatar = ({ type, sx }: ThreadAvatarProps & SharedAvatarProps) => {
    switch (type) {
        case 'chat':
            return <MessageAvatar sx={sx} />
        case 'task':
            return <TaskMessageAvatar sx={sx} />
        case 'system':
            return <SystemMessageAvatar sx={sx} />
        default:
            return <MessageAvatar sx={sx} />
    }
}

export default ThreadAvatar
